import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Hook to remove trailing slashes from the current pathname.
 * Redirects to the pathname without trailing slash (except for root "/").
 * This should be called once at the app level to handle trailing slashes.
 */
export const useRemoveTrailingSlash = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the pathname has a trailing slash (but not for root "/")
    if (location.pathname !== "/" && location.pathname.endsWith("/")) {
      // Remove the trailing slash
      const newPath = location.pathname.slice(0, -1);
      navigate(newPath, { replace: true });
    }
  }, [location.pathname, navigate]);
};

